/* eslint-disable max-len, no-use-before-define */
import _, { isElement, includes } from 'lodash';

let form;

const addListener = (element, method, event) => {
  if (!element === null && !element === undefined) {
    element.addEventListener(method, event, false);
  }
};

const assignFilters = classNames => {
  const filters = {};

  classNames.forEach(className => {
    filters[className] = form.querySelectorAll(`.${className}`);
  });

  return filters;
};

const assignSelects = classNames => {
  if (!classNames === undefined && classNames.length > 0) {
    const selects = {};

    classNames.forEach(className => {
      selects[className] = form.querySelector(`.${className}-select`);
    });

    return selects;
  }
};

const hideAllFilters = filters => {
  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      const nodeList = filters[key];

      nodeList.forEach(filter => {
        const { className } = filter;
        filter.className = className.replace(/(?:^|\s)open(?!\S)/g, '');

        filter.querySelectorAll('input,select').forEach(ip => {
          ip.disabled = true;
        });
      });
    }
  }
};

const selectChange = (select, filters) => {
  const value = select.value.toLowerCase();

  hideAllFilters(filters);
  showFilter(value, filters);
};

const showFilter = (value, filters) => {
  let className;

  filters[value].forEach(filter => {
    className = filter.className;

    if (includes(className, 'filter')) {
      filter.className = `${className} open`;
      filter.querySelectorAll('input,select').forEach(ip => {
        ip.disabled = false;
      });
    }
  });
};

export default function(formId) {
  let config;
  let filters;
  let object;
  let selects;

  form = document.getElementById(formId);

  if (!isElement(form)) return;

  object = {
    config: (options = {}) => {
      config = options;
    },
    init: () => {
      filters = assignFilters(config.filterClasses);
      selects = assignSelects(config.selectClasses);
      addListener(selects.type, 'change', selectChange.bind(null, selects.type, filters));
      showFilter(selects.type.value.toLowerCase(), filters);
    },
  };

  return object;
}
/* eslint-enable */
